import { Button as AntButton, Descriptions, Modal } from "antd";
import { FC, ReactNode, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import { getSurveyStudentDetail } from "../../../../api/surveyQuestion.api";
import useAxios from "../../../../hooks/useAxios";
import { IGetSurveyStudentDetail, ISurveyStudent, ISurveyStudentDetailQuestion } from "../../../../models/surveyQuestion.model";
import ErrorResponse from "../../../ErrorResponse";
import Loader from "../../../Loader";

const Block = styled.div`
  .selected {
    background-color: #e6e6e6;
  }
`;

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  surveyCode: number|undefined;
  record: ISurveyStudent|undefined;
}

const SurveyStudentDetailModal: FC<IProps> = ({
  visible,
  setVisible,
  surveyCode,
  record,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetSurveyStudentDetail>();

  useEffect(() => {
    if (surveyCode && record) {
      execute(getSurveyStudentDetail(surveyCode, record.memberCode));
    }
  }, [surveyCode, record]);

  const renderQuestionTable = (question: ISurveyStudentDetailQuestion, index: number) => {
    return (
      <table className="table table-bordered mt-3">
        <tbody>
          <tr>
            <th className="text-center" colSpan={2}>{index + 1}. {question.title}</th>
          </tr>
          {renderAnswer(question.answerQuestionDetailCode, question.items)}
        </tbody>
      </table>
    );
  }

  const renderAnswer = (answerCode: number|null, items: any) => {
    // 객관식 처리
    if (answerCode) {
      const nodes: ReactNode[] = [];
      items.forEach((item: any) => {
        nodes.push(
          <tr
            key={item.questionDetailCode}
            className={answerCode === item.questionDetailCode ? 'selected' : ''}
          >
            <td>{item.questionContent}</td>
            <td>{item.score}</td>
          </tr>
        );
      });
      return nodes;
    }

    // 주관식 처리
    return (
      <tr>
        <td colSpan={2}>{items?.at(0)?.answer}</td>
      </tr>
    );
  }

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Modal
        title={t('homepage.survey.title6')}
        visible={visible}
        width={750}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <Block>
          <Descriptions
            bordered
            column={5}
            size="small"
          >
            <Descriptions.Item label={t('common.menu.campus')}>
              {res?.data?.campusName}
            </Descriptions.Item>
            <Descriptions.Item label={t('event.briefing.column5')}>
              {res?.data?.memberName}
            </Descriptions.Item>
            <Descriptions.Item label={t('homepage.archive.column4')}>
              {res?.data?.courseName}
            </Descriptions.Item>
            <Descriptions.Item label={t('common.menu.class')}>
              {res?.data?.className}
            </Descriptions.Item>
            <Descriptions.Item label={t('homepage.survey.column8')}>
              {record?.score?.toFixed(1)}
            </Descriptions.Item>
          </Descriptions>

          <table className="table table-bordered mt-3">
            <tbody>
              <tr>
                <th className="text-center">{t('homepage.survey.column11')}</th>
              </tr>
              <tr>
                <td>
                  {res?.data?.questions?.map((item, index) => renderQuestionTable(item, index))}
                </td>
              </tr>
            </tbody>
          </table>
        </Block>
      </Modal>
    </>
  );
}

export default SurveyStudentDetailModal;
